import { actions } from './../../policies/store/actions';
import { getters } from './../../policies/store/getters';
import { mutations } from './../../policies/store/mutations';
import state from './state';

const FormStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
export default FormStore;
